export default (data) => ({
  availabilities: data.availabilities,
  activeAvailability: data.availabilities[0],
  active: 0,
  prev() {
    this.active =
      this.active === 0 ? this.availabilities.length - 1 : this.active - 1;
    this.activeAvailability = this.availabilities[this.active];

    this.getSelectedFloors();
  },
  next() {
    this.active =
      this.active === this.availabilities.length - 1 ? 0 : this.active + 1;
    this.activeAvailability = this.availabilities[this.active];

    this.getSelectedFloors();
  },
  getSelectedFloors() {
    document.querySelectorAll('[id$="Highlighted"]').forEach((el) => {
      el.style.opacity = 0;
    });

    let arr = [];
    this.activeAvailability.floors.forEach((el) => {
      arr.push(`[id^="${el}"][id$="Highlighted"]`);
    });

    document.querySelectorAll(arr.join(',')).forEach((el) => {
      el.style.opacity = 1;
    });
  },
  init() {
    this.getSelectedFloors();
  },
});
